<template>
    <div style="text-align: center;min-height: 450px;display: flex;align-items: center;justify-content: center;flex-direction:column;">
			<div style="margin-top: -60px;padding: 5px;">
				请选择您要上传的模板类型:
				<el-select v-model="excelType" placeholder="请选择" style="margin-left: 10px;width: 250px;margin-bottom: 20px;" size="small">
					<el-option v-for="item in excelOptions" :key="item.id" :label="item.securityname" :value="item.id">
					</el-option>
				</el-select>
			</div>
			<el-upload ref="upload" drag :show-file-list="false" :on-progress="onProgress" :on-change="onChange"
								 :on-success="uploadSuccess" :on-error="uploadError" :before-upload="beforeUpload" :action="getUploadUrl()" v-loading="uploading">
				<i class="el-icon-upload"></i>
				<div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
				<div class="el-upload__tip" slot="tip" style="font-size: 13px;">
					注意:仅支持上传指定格式的Excel模板文件。
				</div>
			</el-upload>
			<el-row class="upload-result" v-if="uploadResult.name!='' && validate == true">
				<el-col :span="20">
					<div class="upload-result-content">
						<div class="title">{{uploadResult.name}}</div>
					</div>
				</el-col>
				<el-col :span="4">
					<div class="upload-result-content">
						<el-progress :percentage="uploadResult.percent" type="circle" :width="50"></el-progress>
					</div>
				</el-col>
			</el-row>
			<el-row v-if="uploadResult.name!='' && validate == true && uploadResult.url!=''">
				<a :href="uploadResult.url">{{uploadResult.msg}}</a>
			</el-row>
			<el-link type="primary" icon="el-icon-download" style="margin-top: 50px;" href="https://cdn.meetingmeet.com/demo/%E4%BA%A7%E5%93%81%E5%87%80%E5%80%BC%E6%A8%A1%E6%9D%BF.xls">点我下载Excel模板</el-link>
			<!--<el-link type="primary" icon="el-icon-download" href="https://cdn.meetingmeet.com/demo/%E4%BA%A7%E5%93%81%E5%87%80%E5%80%BC%E6%A8%A1%E6%9D%BF.xls">点我下载国泰君安Excel模板</el-link>-->
		</div>
</template>

<script>
	import config from "../../../config/global.js";
	import axios from "axios";

	var uploadUrl = config.host+"/backend/excel/uploadnetvalue";
	var getProductUploadConfigUrl = config.host+"/backend/org/getexcelconfiglist.json";

    export default {
    	name: "upload-product-net",
			data:function () {
				return {
					excelType:"",
					uploadResult:{name:"",percent:0,url:"",msg:"",status:""},
					excelOptions:[],
					uploading:false,
					loading:false,
					validate:false
				}
			},
			mounted:function () {
				this.getProductUploadConfig();
			},
			methods:{
				getProductUploadConfig:function () {
					if( this.loading == false ){
						this.loading = true;
						axios({
							method: 'get',
							url:getProductUploadConfigUrl
						}).then((response)=>{
							var defaultResult = this.responseDefaultHandle(response);
							if(defaultResult == false )
								return;
							if(response.data.result == 1){
								this.$message({
									message: '获取数据成功',
									type: 'success'
								});

								this.excelOptions = response.data.items;
							}else{
								this.$alert(response.data.emsg, '获取数据失败', {
									confirmButtonText: '确定'
								});
							}
							this.loading = false;
						}).catch((error)=>{
							this.loading = false;
							this.$alert(error.response.statusText, '获取数据失败', {
								confirmButtonText: '确定'
							});
						})
					}
				},
    		getUploadUrl:function () {
					return uploadUrl+"?configid="+this.excelType;
				},
				beforeUpload:function (file) {
					// var isExcel = false;
					// if(file.type == 'xlsx' || file.type == 'xls'){
					// 	isExcel = true;
					// }
					// var isLt100M = file.size / 1024 / 1024 < 1;
                    // //
					// // if (!isExcel) {
					// // 	this.$message.error('请上传Excel格式文件');
					// // }
					// if (!isLt100M) {
					// 	this.$message.error('上传的Excel文件不能超过 100MB!');
					// }
					// return isLt100M;
					if(this.excelType == null || this.excelType == ''){
						this.$message.error('请选择您要上传的模板类型!');
						this.validate = false;
						return false;
					}
					this.uploading = true;
					this.validate = true;
					return true;
				},
				onChange:function(file, fileList){
					this.uploadResult.name = file.name;
				},
				onProgress:function (event, file, fileList) {
					this.uploadResult.percent = event.percent;
				},
				uploadSuccess:function (response, file, fileList) {
					this.uploading = false;
					if(response.result == 1){
						var msg = "文件已上传，成功"+response.succeetotal+"条,失败"+response.errortotal+"条";
						if(response.errortotal>0){
							var fileObject = fileList[0];
							this.uploadResult.msg = "上传结果:成功"+response.succeetotal+"条,失败"+response.errortotal+"条.点击下载失败记录";
							this.uploadResult.url = response.errorexcelurl;
						}else{
							var fileObject = fileList[0];
							this.uploadResult.msg = "上传结果:成功.共"+response.succeetotal+"条记录";
							this.uploadResult.url = "";
						}
						this.$refs.upload.clearFiles();
						this.$alert(msg, '提示', {
							confirmButtonText: '确定',
						})
						this.$emit("uploadsuccess");
					}else{
						this.$alert("上传失败,请重试", '提示', {
							confirmButtonText: '确定',
						})
					}
				},
				uploadError:function () {
					this.uploading = false;
					this.$message.error('上传失败,请重试');
				}
    	}
    }
</script>

<style scoped>
	.el-dialog__header{
		padding: 5px 10px;
	}

	.upload-result{
		background-color: #fdefab;
		border-radius: 5px;
		line-height: 20px;
		min-height: 60px;
		margin: 10px;
		width: 80%;
	}

	.upload-result .title{
		font-size: 14px;
		color: #606266;
		margin: 5px;
		overflow: hidden;
		text-overflow: ellipsis;
		white-space: nowrap;
		width: 100%;
	}

	.upload-result a{
		font-size: 12px;
		color: #F23946;
		margin: 5px;
	}

	.upload-result-content{
		height: 60px;
		display: flex;
		justify-content: center;
		align-items: center;
		flex-direction: column;
	}
</style>



// WEBPACK FOOTER //
// src/layouts/product/UploadProductNetPanel.vue